import 'xterm/css/xterm.css'
import bluebird from 'bluebird'
import React, { useEffect, useState, useRef } from 'react'
import Loading from '../system/Loading'
import { makeStyles } from '@material-ui/core/styles'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import { v4 as uuid } from 'uuid'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  ssh: {
    width: '100%',
    height: '100%',
    backgroundColor: '#000'
  }
}))

const SSH = ({
  pool,
  lease,
  onSubscribe,
  onUnsubscribe,
  onWrite,
  onError,
}) => {
  const classes = useStyles()
  const rootDom = useRef()
  const dom = useRef()
  const terminal = useRef()

  useEffect(() => {
    dom.current.style.height = rootDom.current.clientHeight + 'px'
    terminal.current = new Terminal()
    const fitAddon = new FitAddon()
    terminal.current.loadAddon(fitAddon)
    terminal.current.open(dom.current)
    fitAddon.fit()

    let sessionOpen = false

    const session = {
      backend_id: lease.backend,
      pool_id: pool.id,
      vm_id: lease.vm,
      session_id: uuid(),
      tty: true,
      command: '',
      term: 'xterm-256color',
      width: terminal.current.cols,
      height: terminal.current.rows,
    }

    const readChannel = ['ssh_client', session.backend_id, session.pool_id, session.session_id].join('.')
    const writeChannel = ['ssh_server', session.backend_id, session.pool_id, session.session_id].join('.')
    const backendChannel = ['backend', session.backend_id].join('.')

    const writeStdin = (data) => {
      onWrite({
        channel: writeChannel,
        messageType: 'stdin',
        body: btoa(data),
      })
    }

    const writeCommand = ({
      name,
      data,
      exitCode,
    }) => {
      onWrite({
        channel: writeChannel,
        messageType: 'command',
        body: JSON.stringify({
          name,
          data,
          exitCode,
        }),
      })
    }

    const connectSSHSession = async () => {
      onWrite({
        channel: backendChannel,
        messageType: 'ssh_session',
        body: JSON.stringify(session),
      })

      let attempts = 0

      while(!sessionOpen && attempts < 10) {
        await bluebird.delay(1000)
        attempts++
      }

      if(!sessionOpen) {
        onError(`We could not open an SSH session within 10 seconds`)
      }
    }

    terminal.current.onData(writeStdin)

    onSubscribe(readChannel, ({
      channel,
      messageType,
      body,
    }) => {
      if(messageType == 'command') {
        const {
          name,
        } = JSON.parse(body)
        if(name == 'connected') {
          sessionOpen = true
        }
        else if(name == 'exit') {
          onError(`the remote SSH connection terminated`)
        }
      }
      else {
        const decoded = atob(body)
        terminal.current.write(decoded)
      }
    })

    connectSSHSession()

    terminal.current.focus()

    // signal to the backend we don't need this SSH connection anymore
    return () => {
      onUnsubscribe(readChannel)
      writeCommand({
        name: 'stdin-eof',
        data: JSON.stringify(session),
        exitCode: 0,
      })
      
    }
  }, [])

  return (
    <div className={ classes.root } ref={ rootDom }>
      <div className={ classes.ssh } ref={ dom }>
      </div>
    </div>
  )
}

export default SSH
